import { defineComponent as kr, toRefs as Nr, unref as ie, ref as Tr, computed as Cr, onMounted as Fr, openBlock as _r, createElementBlock as Ur, normalizeClass as be, createElementVNode as Ue, toDisplayString as je, createTextVNode as rt, createVNode as Br, withCtx as Dr, createCommentVNode as Ir, h as Lr, render as Mr } from "vue";
import { BButton as Wr } from "@bilibili-intl/components";
var qr = Object.create, Vt = Object.defineProperty, zr = Object.getOwnPropertyDescriptor, Vr = Object.getOwnPropertyNames, $r = Object.getPrototypeOf, Hr = Object.prototype.hasOwnProperty, z = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), Jr = (e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let o of Vr(t))
      !Hr.call(e, o) && o !== r && Vt(e, o, { get: () => t[o], enumerable: !(n = zr(t, o)) || n.enumerable });
  return e;
}, Gr = (e, t, r) => (r = e != null ? qr($r(e)) : {}, Jr(t || !e || !e.__esModule ? Vt(r, "default", { value: e, enumerable: !0 }) : r, e)), Kr = z((e, t) => {
  t.exports = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var r = {}, n = Symbol("test"), o = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(o) !== "[object Symbol]")
      return !1;
    var i = 42;
    r[n] = i;
    for (n in r)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(r).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(r).length !== 0)
      return !1;
    var a = Object.getOwnPropertySymbols(r);
    if (a.length !== 1 || a[0] !== n || !Object.prototype.propertyIsEnumerable.call(r, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var d = Object.getOwnPropertyDescriptor(r, n);
      if (d.value !== i || d.enumerable !== !0)
        return !1;
    }
    return !0;
  };
}), Qr = z((e, t) => {
  var r = typeof Symbol != "undefined" && Symbol, n = Kr();
  t.exports = function() {
    return typeof r != "function" || typeof Symbol != "function" || typeof r("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : n();
  };
}), Xr = z((e, t) => {
  var r = "Function.prototype.bind called on incompatible ", n = Array.prototype.slice, o = Object.prototype.toString, i = "[object Function]";
  t.exports = function(a) {
    var d = this;
    if (typeof d != "function" || o.call(d) !== i)
      throw new TypeError(r + d);
    for (var p = n.call(arguments, 1), S, v = function() {
      if (this instanceof S) {
        var A = d.apply(this, p.concat(n.call(arguments)));
        return Object(A) === A ? A : this;
      } else
        return d.apply(a, p.concat(n.call(arguments)));
    }, O = Math.max(0, d.length - p.length), x = [], m = 0; m < O; m++)
      x.push("$" + m);
    if (S = Function("binder", "return function (" + x.join(",") + "){ return binder.apply(this,arguments); }")(v), d.prototype) {
      var f = function() {
      };
      f.prototype = d.prototype, S.prototype = new f(), f.prototype = null;
    }
    return S;
  };
}), ft = z((e, t) => {
  var r = Xr();
  t.exports = Function.prototype.bind || r;
}), Zr = z((e, t) => {
  var r = ft();
  t.exports = r.call(Function.call, Object.prototype.hasOwnProperty);
}), pt = z((e, t) => {
  var r, n = SyntaxError, o = Function, i = TypeError, a = function(T) {
    try {
      return o('"use strict"; return (' + T + ").constructor;")();
    } catch (U) {
    }
  }, d = Object.getOwnPropertyDescriptor;
  if (d)
    try {
      d({}, "");
    } catch (T) {
      d = null;
    }
  var p = function() {
    throw new i();
  }, S = d ? function() {
    try {
      return arguments.callee, p;
    } catch (T) {
      try {
        return d(arguments, "callee").get;
      } catch (U) {
        return p;
      }
    }
  }() : p, v = Qr()(), O = Object.getPrototypeOf || function(T) {
    return T.__proto__;
  }, x = {}, m = typeof Uint8Array == "undefined" ? r : O(Uint8Array), f = { "%AggregateError%": typeof AggregateError == "undefined" ? r : AggregateError, "%Array%": Array, "%ArrayBuffer%": typeof ArrayBuffer == "undefined" ? r : ArrayBuffer, "%ArrayIteratorPrototype%": v ? O([][Symbol.iterator]()) : r, "%AsyncFromSyncIteratorPrototype%": r, "%AsyncFunction%": x, "%AsyncGenerator%": x, "%AsyncGeneratorFunction%": x, "%AsyncIteratorPrototype%": x, "%Atomics%": typeof Atomics == "undefined" ? r : Atomics, "%BigInt%": typeof BigInt == "undefined" ? r : BigInt, "%BigInt64Array%": typeof BigInt64Array == "undefined" ? r : BigInt64Array, "%BigUint64Array%": typeof BigUint64Array == "undefined" ? r : BigUint64Array, "%Boolean%": Boolean, "%DataView%": typeof DataView == "undefined" ? r : DataView, "%Date%": Date, "%decodeURI%": decodeURI, "%decodeURIComponent%": decodeURIComponent, "%encodeURI%": encodeURI, "%encodeURIComponent%": encodeURIComponent, "%Error%": Error, "%eval%": eval, "%EvalError%": EvalError, "%Float32Array%": typeof Float32Array == "undefined" ? r : Float32Array, "%Float64Array%": typeof Float64Array == "undefined" ? r : Float64Array, "%FinalizationRegistry%": typeof FinalizationRegistry == "undefined" ? r : FinalizationRegistry, "%Function%": o, "%GeneratorFunction%": x, "%Int8Array%": typeof Int8Array == "undefined" ? r : Int8Array, "%Int16Array%": typeof Int16Array == "undefined" ? r : Int16Array, "%Int32Array%": typeof Int32Array == "undefined" ? r : Int32Array, "%isFinite%": isFinite, "%isNaN%": isNaN, "%IteratorPrototype%": v ? O(O([][Symbol.iterator]())) : r, "%JSON%": typeof JSON == "object" ? JSON : r, "%Map%": typeof Map == "undefined" ? r : Map, "%MapIteratorPrototype%": typeof Map == "undefined" || !v ? r : O((/* @__PURE__ */ new Map())[Symbol.iterator]()), "%Math%": Math, "%Number%": Number, "%Object%": Object, "%parseFloat%": parseFloat, "%parseInt%": parseInt, "%Promise%": typeof Promise == "undefined" ? r : Promise, "%Proxy%": typeof Proxy == "undefined" ? r : Proxy, "%RangeError%": RangeError, "%ReferenceError%": ReferenceError, "%Reflect%": typeof Reflect == "undefined" ? r : Reflect, "%RegExp%": RegExp, "%Set%": typeof Set == "undefined" ? r : Set, "%SetIteratorPrototype%": typeof Set == "undefined" || !v ? r : O((/* @__PURE__ */ new Set())[Symbol.iterator]()), "%SharedArrayBuffer%": typeof SharedArrayBuffer == "undefined" ? r : SharedArrayBuffer, "%String%": String, "%StringIteratorPrototype%": v ? O(""[Symbol.iterator]()) : r, "%Symbol%": v ? Symbol : r, "%SyntaxError%": n, "%ThrowTypeError%": S, "%TypedArray%": m, "%TypeError%": i, "%Uint8Array%": typeof Uint8Array == "undefined" ? r : Uint8Array, "%Uint8ClampedArray%": typeof Uint8ClampedArray == "undefined" ? r : Uint8ClampedArray, "%Uint16Array%": typeof Uint16Array == "undefined" ? r : Uint16Array, "%Uint32Array%": typeof Uint32Array == "undefined" ? r : Uint32Array, "%URIError%": URIError, "%WeakMap%": typeof WeakMap == "undefined" ? r : WeakMap, "%WeakRef%": typeof WeakRef == "undefined" ? r : WeakRef, "%WeakSet%": typeof WeakSet == "undefined" ? r : WeakSet };
  try {
    null.error;
  } catch (T) {
    A = O(O(T)), f["%Error.prototype%"] = A;
  }
  var A, P = function T(U) {
    var k;
    if (U === "%AsyncFunction%")
      k = a("async function () {}");
    else if (U === "%GeneratorFunction%")
      k = a("function* () {}");
    else if (U === "%AsyncGeneratorFunction%")
      k = a("async function* () {}");
    else if (U === "%AsyncGenerator%") {
      var B = T("%AsyncGeneratorFunction%");
      B && (k = B.prototype);
    } else if (U === "%AsyncIteratorPrototype%") {
      var C = T("%AsyncGenerator%");
      C && (k = O(C.prototype));
    }
    return f[U] = k, k;
  }, w = { "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"], "%ArrayPrototype%": ["Array", "prototype"], "%ArrayProto_entries%": ["Array", "prototype", "entries"], "%ArrayProto_forEach%": ["Array", "prototype", "forEach"], "%ArrayProto_keys%": ["Array", "prototype", "keys"], "%ArrayProto_values%": ["Array", "prototype", "values"], "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"], "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"], "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"], "%BooleanPrototype%": ["Boolean", "prototype"], "%DataViewPrototype%": ["DataView", "prototype"], "%DatePrototype%": ["Date", "prototype"], "%ErrorPrototype%": ["Error", "prototype"], "%EvalErrorPrototype%": ["EvalError", "prototype"], "%Float32ArrayPrototype%": ["Float32Array", "prototype"], "%Float64ArrayPrototype%": ["Float64Array", "prototype"], "%FunctionPrototype%": ["Function", "prototype"], "%Generator%": ["GeneratorFunction", "prototype"], "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"], "%Int8ArrayPrototype%": ["Int8Array", "prototype"], "%Int16ArrayPrototype%": ["Int16Array", "prototype"], "%Int32ArrayPrototype%": ["Int32Array", "prototype"], "%JSONParse%": ["JSON", "parse"], "%JSONStringify%": ["JSON", "stringify"], "%MapPrototype%": ["Map", "prototype"], "%NumberPrototype%": ["Number", "prototype"], "%ObjectPrototype%": ["Object", "prototype"], "%ObjProto_toString%": ["Object", "prototype", "toString"], "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"], "%PromisePrototype%": ["Promise", "prototype"], "%PromiseProto_then%": ["Promise", "prototype", "then"], "%Promise_all%": ["Promise", "all"], "%Promise_reject%": ["Promise", "reject"], "%Promise_resolve%": ["Promise", "resolve"], "%RangeErrorPrototype%": ["RangeError", "prototype"], "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"], "%RegExpPrototype%": ["RegExp", "prototype"], "%SetPrototype%": ["Set", "prototype"], "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"], "%StringPrototype%": ["String", "prototype"], "%SymbolPrototype%": ["Symbol", "prototype"], "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"], "%TypedArrayPrototype%": ["TypedArray", "prototype"], "%TypeErrorPrototype%": ["TypeError", "prototype"], "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"], "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"], "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"], "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"], "%URIErrorPrototype%": ["URIError", "prototype"], "%WeakMapPrototype%": ["WeakMap", "prototype"], "%WeakSetPrototype%": ["WeakSet", "prototype"] }, s = ft(), h = Zr(), g = s.call(Function.call, Array.prototype.concat), y = s.call(Function.apply, Array.prototype.splice), b = s.call(Function.call, String.prototype.replace), E = s.call(Function.call, String.prototype.slice), _ = s.call(Function.call, RegExp.prototype.exec), j = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, F = /\\(\\)?/g, M = function(T) {
    var U = E(T, 0, 1), k = E(T, -1);
    if (U === "%" && k !== "%")
      throw new n("invalid intrinsic syntax, expected closing `%`");
    if (k === "%" && U !== "%")
      throw new n("invalid intrinsic syntax, expected opening `%`");
    var B = [];
    return b(T, j, function(C, $, R, J) {
      B[B.length] = R ? b(J, F, "$1") : $ || C;
    }), B;
  }, Q = function(T, U) {
    var k = T, B;
    if (h(w, k) && (B = w[k], k = "%" + B[0] + "%"), h(f, k)) {
      var C = f[k];
      if (C === x && (C = P(k)), typeof C == "undefined" && !U)
        throw new i("intrinsic " + T + " exists, but is not available. Please file an issue!");
      return { alias: B, name: k, value: C };
    }
    throw new n("intrinsic " + T + " does not exist!");
  };
  t.exports = function(T, U) {
    if (typeof T != "string" || T.length === 0)
      throw new i("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof U != "boolean")
      throw new i('"allowMissing" argument must be a boolean');
    if (_(/^%?[^%]*%?$/, T) === null)
      throw new n("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var k = M(T), B = k.length > 0 ? k[0] : "", C = Q("%" + B + "%", U), $ = C.name, R = C.value, J = !1, G = C.alias;
    G && (B = G[0], y(k, g([0, 1], G)));
    for (var re = 1, X = !0; re < k.length; re += 1) {
      var V = k[re], ne = E(V, 0, 1), Z = E(V, -1);
      if ((ne === '"' || ne === "'" || ne === "`" || Z === '"' || Z === "'" || Z === "`") && ne !== Z)
        throw new n("property names with quotes must have matching quotes");
      if ((V === "constructor" || !X) && (J = !0), B += "." + V, $ = "%" + B + "%", h(f, $))
        R = f[$];
      else if (R != null) {
        if (!(V in R)) {
          if (!U)
            throw new i("base intrinsic for " + T + " exists, but the property is not available.");
          return;
        }
        if (d && re + 1 >= k.length) {
          var Y = d(R, V);
          X = !!Y, X && "get" in Y && !("originalValue" in Y.get) ? R = Y.get : R = R[V];
        } else
          X = h(R, V), R = R[V];
        X && !J && (f[$] = R);
      }
    }
    return R;
  };
}), Yr = z((e, t) => {
  var r = ft(), n = pt(), o = n("%Function.prototype.apply%"), i = n("%Function.prototype.call%"), a = n("%Reflect.apply%", !0) || r.call(i, o), d = n("%Object.getOwnPropertyDescriptor%", !0), p = n("%Object.defineProperty%", !0), S = n("%Math.max%");
  if (p)
    try {
      p({}, "a", { value: 1 });
    } catch (O) {
      p = null;
    }
  t.exports = function(O) {
    var x = a(r, i, arguments);
    if (d && p) {
      var m = d(x, "length");
      m.configurable && p(x, "length", { value: 1 + S(0, O.length - (arguments.length - 1)) });
    }
    return x;
  };
  var v = function() {
    return a(r, o, arguments);
  };
  p ? p(t.exports, "apply", { value: v }) : t.exports.apply = v;
}), en = z((e, t) => {
  var r = pt(), n = Yr(), o = n(r("String.prototype.indexOf"));
  t.exports = function(i, a) {
    var d = r(i, !!a);
    return typeof d == "function" && o(i, ".prototype.") > -1 ? n(d) : d;
  };
}), tn = z(() => {
}), rn = z((e, t) => {
  var r = typeof Map == "function" && Map.prototype, n = Object.getOwnPropertyDescriptor && r ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, o = r && n && typeof n.get == "function" ? n.get : null, i = r && Map.prototype.forEach, a = typeof Set == "function" && Set.prototype, d = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, p = a && d && typeof d.get == "function" ? d.get : null, S = a && Set.prototype.forEach, v = typeof WeakMap == "function" && WeakMap.prototype, O = v ? WeakMap.prototype.has : null, x = typeof WeakSet == "function" && WeakSet.prototype, m = x ? WeakSet.prototype.has : null, f = typeof WeakRef == "function" && WeakRef.prototype, A = f ? WeakRef.prototype.deref : null, P = Boolean.prototype.valueOf, w = Object.prototype.toString, s = Function.prototype.toString, h = String.prototype.match, g = String.prototype.slice, y = String.prototype.replace, b = String.prototype.toUpperCase, E = String.prototype.toLowerCase, _ = RegExp.prototype.test, j = Array.prototype.concat, F = Array.prototype.join, M = Array.prototype.slice, Q = Math.floor, T = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, U = Object.getOwnPropertySymbols, k = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, B = typeof Symbol == "function" && typeof Symbol.iterator == "object", C = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === B || "symbol") ? Symbol.toStringTag : null, $ = Object.prototype.propertyIsEnumerable, R = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(l) {
    return l.__proto__;
  } : null);
  function J(l, u) {
    if (l === 1 / 0 || l === -1 / 0 || l !== l || l && l > -1e3 && l < 1e3 || _.call(/e/, u))
      return u;
    var D = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof l == "number") {
      var L = l < 0 ? -Q(-l) : Q(l);
      if (L !== l) {
        var W = String(L), N = g.call(u, W.length + 1);
        return y.call(W, D, "$&_") + "." + y.call(y.call(N, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return y.call(u, D, "$&_");
  }
  var G = tn(), re = G.custom, X = oe(re) ? re : null;
  t.exports = function l(u, D, L, W) {
    var N = D || {};
    if (ee(N, "quoteStyle") && N.quoteStyle !== "single" && N.quoteStyle !== "double")
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (ee(N, "maxStringLength") && (typeof N.maxStringLength == "number" ? N.maxStringLength < 0 && N.maxStringLength !== 1 / 0 : N.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var ue = ee(N, "customInspect") ? N.customInspect : !0;
    if (typeof ue != "boolean" && ue !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (ee(N, "indent") && N.indent !== null && N.indent !== "	" && !(parseInt(N.indent, 10) === N.indent && N.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (ee(N, "numericSeparator") && typeof N.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var de = N.numericSeparator;
    if (typeof u == "undefined")
      return "undefined";
    if (u === null)
      return "null";
    if (typeof u == "boolean")
      return u ? "true" : "false";
    if (typeof u == "string")
      return St(u, N);
    if (typeof u == "number") {
      if (u === 0)
        return 1 / 0 / u > 0 ? "0" : "-0";
      var H = String(u);
      return de ? J(u, H) : H;
    }
    if (typeof u == "bigint") {
      var ce = String(u) + "n";
      return de ? J(u, ce) : ce;
    }
    var Ke = typeof N.depth == "undefined" ? 5 : N.depth;
    if (typeof L == "undefined" && (L = 0), L >= Ke && Ke > 0 && typeof u == "object")
      return Z(u) ? "[Array]" : "[Object]";
    var he = jr(N, L);
    if (typeof W == "undefined")
      W = [];
    else if (vt(W, u) >= 0)
      return "[Circular]";
    function te(ge, _e, Rr) {
      if (_e && (W = M.call(W), W.push(_e)), Rr) {
        var kt = { depth: N.depth };
        return ee(N, "quoteStyle") && (kt.quoteStyle = N.quoteStyle), l(ge, kt, L + 1, W);
      }
      return l(ge, N, L + 1, W);
    }
    if (typeof u == "function" && !me(u)) {
      var Et = gr(u), Ot = Ce(u, te);
      return "[Function" + (Et ? ": " + Et : " (anonymous)") + "]" + (Ot.length > 0 ? " { " + F.call(Ot, ", ") + " }" : "");
    }
    if (oe(u)) {
      var At = B ? y.call(String(u), /^(Symbol\(.*\))_[^)]*$/, "$1") : k.call(u);
      return typeof u == "object" && !B ? Ae(At) : At;
    }
    if (Or(u)) {
      for (var Pe = "<" + E.call(String(u.nodeName)), Qe = u.attributes || [], Fe = 0; Fe < Qe.length; Fe++)
        Pe += " " + Qe[Fe].name + "=" + V(ne(Qe[Fe].value), "double", N);
      return Pe += ">", u.childNodes && u.childNodes.length && (Pe += "..."), Pe += "</" + E.call(String(u.nodeName)) + ">", Pe;
    }
    if (Z(u)) {
      if (u.length === 0)
        return "[]";
      var Xe = Ce(u, te);
      return he && !Pr(Xe) ? "[" + Ge(Xe, he) + "]" : "[ " + F.call(Xe, ", ") + " ]";
    }
    if (ye(u)) {
      var Ze = Ce(u, te);
      return !("cause" in Error.prototype) && "cause" in u && !$.call(u, "cause") ? "{ [" + String(u) + "] " + F.call(j.call("[cause]: " + te(u.cause), Ze), ", ") + " }" : Ze.length === 0 ? "[" + String(u) + "]" : "{ [" + String(u) + "] " + F.call(Ze, ", ") + " }";
    }
    if (typeof u == "object" && ue) {
      if (X && typeof u[X] == "function" && G)
        return G(u, { depth: Ke - L });
      if (ue !== "symbol" && typeof u.inspect == "function")
        return u.inspect();
    }
    if (br(u)) {
      var Pt = [];
      return i && i.call(u, function(ge, _e) {
        Pt.push(te(_e, u, !0) + " => " + te(ge, u));
      }), wt("Map", o.call(u), Pt, he);
    }
    if (wr(u)) {
      var jt = [];
      return S && S.call(u, function(ge) {
        jt.push(te(ge, u));
      }), wt("Set", p.call(u), jt, he);
    }
    if (vr(u))
      return Je("WeakMap");
    if (Er(u))
      return Je("WeakSet");
    if (Sr(u))
      return Je("WeakRef");
    if (Ee(u))
      return Ae(te(Number(u)));
    if (Te(u))
      return Ae(te(T.call(u)));
    if (Oe(u))
      return Ae(P.call(u));
    if (Ne(u))
      return Ae(te(String(u)));
    if (!Y(u) && !me(u)) {
      var Ye = Ce(u, te), xt = R ? R(u) === Object.prototype : u instanceof Object || u.constructor === Object, et = u instanceof Object ? "" : "null prototype", Rt = !xt && C && Object(u) === u && C in u ? g.call(K(u), 8, -1) : et ? "Object" : "", xr = xt || typeof u.constructor != "function" ? "" : u.constructor.name ? u.constructor.name + " " : "", tt = xr + (Rt || et ? "[" + F.call(j.call([], Rt || [], et || []), ": ") + "] " : "");
      return Ye.length === 0 ? tt + "{}" : he ? tt + "{" + Ge(Ye, he) + "}" : tt + "{ " + F.call(Ye, ", ") + " }";
    }
    return String(u);
  };
  function V(l, u, D) {
    var L = (D.quoteStyle || u) === "double" ? '"' : "'";
    return L + l + L;
  }
  function ne(l) {
    return y.call(String(l), /"/g, "&quot;");
  }
  function Z(l) {
    return K(l) === "[object Array]" && (!C || !(typeof l == "object" && C in l));
  }
  function Y(l) {
    return K(l) === "[object Date]" && (!C || !(typeof l == "object" && C in l));
  }
  function me(l) {
    return K(l) === "[object RegExp]" && (!C || !(typeof l == "object" && C in l));
  }
  function ye(l) {
    return K(l) === "[object Error]" && (!C || !(typeof l == "object" && C in l));
  }
  function Ne(l) {
    return K(l) === "[object String]" && (!C || !(typeof l == "object" && C in l));
  }
  function Ee(l) {
    return K(l) === "[object Number]" && (!C || !(typeof l == "object" && C in l));
  }
  function Oe(l) {
    return K(l) === "[object Boolean]" && (!C || !(typeof l == "object" && C in l));
  }
  function oe(l) {
    if (B)
      return l && typeof l == "object" && l instanceof Symbol;
    if (typeof l == "symbol")
      return !0;
    if (!l || typeof l != "object" || !k)
      return !1;
    try {
      return k.call(l), !0;
    } catch (u) {
    }
    return !1;
  }
  function Te(l) {
    if (!l || typeof l != "object" || !T)
      return !1;
    try {
      return T.call(l), !0;
    } catch (u) {
    }
    return !1;
  }
  var He = Object.prototype.hasOwnProperty || function(l) {
    return l in this;
  };
  function ee(l, u) {
    return He.call(l, u);
  }
  function K(l) {
    return w.call(l);
  }
  function gr(l) {
    if (l.name)
      return l.name;
    var u = h.call(s.call(l), /^function\s*([\w$]+)/);
    return u ? u[1] : null;
  }
  function vt(l, u) {
    if (l.indexOf)
      return l.indexOf(u);
    for (var D = 0, L = l.length; D < L; D++)
      if (l[D] === u)
        return D;
    return -1;
  }
  function br(l) {
    if (!o || !l || typeof l != "object")
      return !1;
    try {
      o.call(l);
      try {
        p.call(l);
      } catch (u) {
        return !0;
      }
      return l instanceof Map;
    } catch (u) {
    }
    return !1;
  }
  function vr(l) {
    if (!O || !l || typeof l != "object")
      return !1;
    try {
      O.call(l, O);
      try {
        m.call(l, m);
      } catch (u) {
        return !0;
      }
      return l instanceof WeakMap;
    } catch (u) {
    }
    return !1;
  }
  function Sr(l) {
    if (!A || !l || typeof l != "object")
      return !1;
    try {
      return A.call(l), !0;
    } catch (u) {
    }
    return !1;
  }
  function wr(l) {
    if (!p || !l || typeof l != "object")
      return !1;
    try {
      p.call(l);
      try {
        o.call(l);
      } catch (u) {
        return !0;
      }
      return l instanceof Set;
    } catch (u) {
    }
    return !1;
  }
  function Er(l) {
    if (!m || !l || typeof l != "object")
      return !1;
    try {
      m.call(l, m);
      try {
        O.call(l, O);
      } catch (u) {
        return !0;
      }
      return l instanceof WeakSet;
    } catch (u) {
    }
    return !1;
  }
  function Or(l) {
    return !l || typeof l != "object" ? !1 : typeof HTMLElement != "undefined" && l instanceof HTMLElement ? !0 : typeof l.nodeName == "string" && typeof l.getAttribute == "function";
  }
  function St(l, u) {
    if (l.length > u.maxStringLength) {
      var D = l.length - u.maxStringLength, L = "... " + D + " more character" + (D > 1 ? "s" : "");
      return St(g.call(l, 0, u.maxStringLength), u) + L;
    }
    var W = y.call(y.call(l, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Ar);
    return V(W, "single", u);
  }
  function Ar(l) {
    var u = l.charCodeAt(0), D = { 8: "b", 9: "t", 10: "n", 12: "f", 13: "r" }[u];
    return D ? "\\" + D : "\\x" + (u < 16 ? "0" : "") + b.call(u.toString(16));
  }
  function Ae(l) {
    return "Object(" + l + ")";
  }
  function Je(l) {
    return l + " { ? }";
  }
  function wt(l, u, D, L) {
    var W = L ? Ge(D, L) : F.call(D, ", ");
    return l + " (" + u + ") {" + W + "}";
  }
  function Pr(l) {
    for (var u = 0; u < l.length; u++)
      if (vt(l[u], `
`) >= 0)
        return !1;
    return !0;
  }
  function jr(l, u) {
    var D;
    if (l.indent === "	")
      D = "	";
    else if (typeof l.indent == "number" && l.indent > 0)
      D = F.call(Array(l.indent + 1), " ");
    else
      return null;
    return { base: D, prev: F.call(Array(u + 1), D) };
  }
  function Ge(l, u) {
    if (l.length === 0)
      return "";
    var D = `
` + u.prev + u.base;
    return D + F.call(l, "," + D) + `
` + u.prev;
  }
  function Ce(l, u) {
    var D = Z(l), L = [];
    if (D) {
      L.length = l.length;
      for (var W = 0; W < l.length; W++)
        L[W] = ee(l, W) ? u(l[W], l) : "";
    }
    var N = typeof U == "function" ? U(l) : [], ue;
    if (B) {
      ue = {};
      for (var de = 0; de < N.length; de++)
        ue["$" + N[de]] = N[de];
    }
    for (var H in l)
      !ee(l, H) || D && String(Number(H)) === H && H < l.length || B && ue["$" + H] instanceof Symbol || (_.call(/[^\w$]/, H) ? L.push(u(H, l) + ": " + u(l[H], l)) : L.push(H + ": " + u(l[H], l)));
    if (typeof U == "function")
      for (var ce = 0; ce < N.length; ce++)
        $.call(l, N[ce]) && L.push("[" + u(N[ce]) + "]: " + u(l[N[ce]], l));
    return L;
  }
}), nn = z((e, t) => {
  var r = pt(), n = en(), o = rn(), i = r("%TypeError%"), a = r("%WeakMap%", !0), d = r("%Map%", !0), p = n("WeakMap.prototype.get", !0), S = n("WeakMap.prototype.set", !0), v = n("WeakMap.prototype.has", !0), O = n("Map.prototype.get", !0), x = n("Map.prototype.set", !0), m = n("Map.prototype.has", !0), f = function(s, h) {
    for (var g = s, y; (y = g.next) !== null; g = y)
      if (y.key === h)
        return g.next = y.next, y.next = s.next, s.next = y, y;
  }, A = function(s, h) {
    var g = f(s, h);
    return g && g.value;
  }, P = function(s, h, g) {
    var y = f(s, h);
    y ? y.value = g : s.next = { key: h, next: s.next, value: g };
  }, w = function(s, h) {
    return !!f(s, h);
  };
  t.exports = function() {
    var s, h, g, y = { assert: function(b) {
      if (!y.has(b))
        throw new i("Side channel does not contain " + o(b));
    }, get: function(b) {
      if (a && b && (typeof b == "object" || typeof b == "function")) {
        if (s)
          return p(s, b);
      } else if (d) {
        if (h)
          return O(h, b);
      } else if (g)
        return A(g, b);
    }, has: function(b) {
      if (a && b && (typeof b == "object" || typeof b == "function")) {
        if (s)
          return v(s, b);
      } else if (d) {
        if (h)
          return m(h, b);
      } else if (g)
        return w(g, b);
      return !1;
    }, set: function(b, E) {
      a && b && (typeof b == "object" || typeof b == "function") ? (s || (s = new a()), S(s, b, E)) : d ? (h || (h = new d()), x(h, b, E)) : (g || (g = { key: {}, next: null }), P(g, b, E));
    } };
    return y;
  };
}), yt = z((e, t) => {
  var r = String.prototype.replace, n = /%20/g, o = { RFC1738: "RFC1738", RFC3986: "RFC3986" };
  t.exports = { default: o.RFC3986, formatters: { RFC1738: function(i) {
    return r.call(i, n, "+");
  }, RFC3986: function(i) {
    return String(i);
  } }, RFC1738: o.RFC1738, RFC3986: o.RFC3986 };
}), $t = z((e, t) => {
  var r = yt(), n = Object.prototype.hasOwnProperty, o = Array.isArray, i = function() {
    for (var w = [], s = 0; s < 256; ++s)
      w.push("%" + ((s < 16 ? "0" : "") + s.toString(16)).toUpperCase());
    return w;
  }(), a = function(w) {
    for (; w.length > 1; ) {
      var s = w.pop(), h = s.obj[s.prop];
      if (o(h)) {
        for (var g = [], y = 0; y < h.length; ++y)
          typeof h[y] != "undefined" && g.push(h[y]);
        s.obj[s.prop] = g;
      }
    }
  }, d = function(w, s) {
    for (var h = s && s.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, g = 0; g < w.length; ++g)
      typeof w[g] != "undefined" && (h[g] = w[g]);
    return h;
  }, p = function w(s, h, g) {
    if (!h)
      return s;
    if (typeof h != "object") {
      if (o(s))
        s.push(h);
      else if (s && typeof s == "object")
        (g && (g.plainObjects || g.allowPrototypes) || !n.call(Object.prototype, h)) && (s[h] = !0);
      else
        return [s, h];
      return s;
    }
    if (!s || typeof s != "object")
      return [s].concat(h);
    var y = s;
    return o(s) && !o(h) && (y = d(s, g)), o(s) && o(h) ? (h.forEach(function(b, E) {
      if (n.call(s, E)) {
        var _ = s[E];
        _ && typeof _ == "object" && b && typeof b == "object" ? s[E] = w(_, b, g) : s.push(b);
      } else
        s[E] = b;
    }), s) : Object.keys(h).reduce(function(b, E) {
      var _ = h[E];
      return n.call(b, E) ? b[E] = w(b[E], _, g) : b[E] = _, b;
    }, y);
  }, S = function(w, s) {
    return Object.keys(s).reduce(function(h, g) {
      return h[g] = s[g], h;
    }, w);
  }, v = function(w, s, h) {
    var g = w.replace(/\+/g, " ");
    if (h === "iso-8859-1")
      return g.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(g);
    } catch (y) {
      return g;
    }
  }, O = function(w, s, h, g, y) {
    if (w.length === 0)
      return w;
    var b = w;
    if (typeof w == "symbol" ? b = Symbol.prototype.toString.call(w) : typeof w != "string" && (b = String(w)), h === "iso-8859-1")
      return escape(b).replace(/%u[0-9a-f]{4}/gi, function(F) {
        return "%26%23" + parseInt(F.slice(2), 16) + "%3B";
      });
    for (var E = "", _ = 0; _ < b.length; ++_) {
      var j = b.charCodeAt(_);
      if (j === 45 || j === 46 || j === 95 || j === 126 || j >= 48 && j <= 57 || j >= 65 && j <= 90 || j >= 97 && j <= 122 || y === r.RFC1738 && (j === 40 || j === 41)) {
        E += b.charAt(_);
        continue;
      }
      if (j < 128) {
        E = E + i[j];
        continue;
      }
      if (j < 2048) {
        E = E + (i[192 | j >> 6] + i[128 | j & 63]);
        continue;
      }
      if (j < 55296 || j >= 57344) {
        E = E + (i[224 | j >> 12] + i[128 | j >> 6 & 63] + i[128 | j & 63]);
        continue;
      }
      _ += 1, j = 65536 + ((j & 1023) << 10 | b.charCodeAt(_) & 1023), E += i[240 | j >> 18] + i[128 | j >> 12 & 63] + i[128 | j >> 6 & 63] + i[128 | j & 63];
    }
    return E;
  }, x = function(w) {
    for (var s = [{ obj: { o: w }, prop: "o" }], h = [], g = 0; g < s.length; ++g)
      for (var y = s[g], b = y.obj[y.prop], E = Object.keys(b), _ = 0; _ < E.length; ++_) {
        var j = E[_], F = b[j];
        typeof F == "object" && F !== null && h.indexOf(F) === -1 && (s.push({ obj: b, prop: j }), h.push(F));
      }
    return a(s), w;
  }, m = function(w) {
    return Object.prototype.toString.call(w) === "[object RegExp]";
  }, f = function(w) {
    return !w || typeof w != "object" ? !1 : !!(w.constructor && w.constructor.isBuffer && w.constructor.isBuffer(w));
  }, A = function(w, s) {
    return [].concat(w, s);
  }, P = function(w, s) {
    if (o(w)) {
      for (var h = [], g = 0; g < w.length; g += 1)
        h.push(s(w[g]));
      return h;
    }
    return s(w);
  };
  t.exports = { arrayToObject: d, assign: S, combine: A, compact: x, decode: v, encode: O, isBuffer: f, isRegExp: m, maybeMap: P, merge: p };
}), on = z((e, t) => {
  var r = nn(), n = $t(), o = yt(), i = Object.prototype.hasOwnProperty, a = { brackets: function(s) {
    return s + "[]";
  }, comma: "comma", indices: function(s, h) {
    return s + "[" + h + "]";
  }, repeat: function(s) {
    return s;
  } }, d = Array.isArray, p = String.prototype.split, S = Array.prototype.push, v = function(s, h) {
    S.apply(s, d(h) ? h : [h]);
  }, O = Date.prototype.toISOString, x = o.default, m = { addQueryPrefix: !1, allowDots: !1, charset: "utf-8", charsetSentinel: !1, delimiter: "&", encode: !0, encoder: n.encode, encodeValuesOnly: !1, format: x, formatter: o.formatters[x], indices: !1, serializeDate: function(s) {
    return O.call(s);
  }, skipNulls: !1, strictNullHandling: !1 }, f = function(s) {
    return typeof s == "string" || typeof s == "number" || typeof s == "boolean" || typeof s == "symbol" || typeof s == "bigint";
  }, A = {}, P = function s(h, g, y, b, E, _, j, F, M, Q, T, U, k, B, C, $) {
    for (var R = h, J = $, G = 0, re = !1; (J = J.get(A)) !== void 0 && !re; ) {
      var X = J.get(h);
      if (G += 1, typeof X != "undefined") {
        if (X === G)
          throw new RangeError("Cyclic object value");
        re = !0;
      }
      typeof J.get(A) == "undefined" && (G = 0);
    }
    if (typeof F == "function" ? R = F(g, R) : R instanceof Date ? R = T(R) : y === "comma" && d(R) && (R = n.maybeMap(R, function(K) {
      return K instanceof Date ? T(K) : K;
    })), R === null) {
      if (E)
        return j && !B ? j(g, m.encoder, C, "key", U) : g;
      R = "";
    }
    if (f(R) || n.isBuffer(R)) {
      if (j) {
        var V = B ? g : j(g, m.encoder, C, "key", U);
        if (y === "comma" && B) {
          for (var ne = p.call(String(R), ","), Z = "", Y = 0; Y < ne.length; ++Y)
            Z += (Y === 0 ? "" : ",") + k(j(ne[Y], m.encoder, C, "value", U));
          return [k(V) + (b && d(R) && ne.length === 1 ? "[]" : "") + "=" + Z];
        }
        return [k(V) + "=" + k(j(R, m.encoder, C, "value", U))];
      }
      return [k(g) + "=" + k(String(R))];
    }
    var me = [];
    if (typeof R == "undefined")
      return me;
    var ye;
    if (y === "comma" && d(R))
      ye = [{ value: R.length > 0 ? R.join(",") || null : void 0 }];
    else if (d(F))
      ye = F;
    else {
      var Ne = Object.keys(R);
      ye = M ? Ne.sort(M) : Ne;
    }
    for (var Ee = b && d(R) && R.length === 1 ? g + "[]" : g, Oe = 0; Oe < ye.length; ++Oe) {
      var oe = ye[Oe], Te = typeof oe == "object" && typeof oe.value != "undefined" ? oe.value : R[oe];
      if (!(_ && Te === null)) {
        var He = d(R) ? typeof y == "function" ? y(Ee, oe) : Ee : Ee + (Q ? "." + oe : "[" + oe + "]");
        $.set(h, G);
        var ee = r();
        ee.set(A, $), v(me, s(Te, He, y, b, E, _, j, F, M, Q, T, U, k, B, C, ee));
      }
    }
    return me;
  }, w = function(s) {
    if (!s)
      return m;
    if (s.encoder !== null && typeof s.encoder != "undefined" && typeof s.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var h = s.charset || m.charset;
    if (typeof s.charset != "undefined" && s.charset !== "utf-8" && s.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var g = o.default;
    if (typeof s.format != "undefined") {
      if (!i.call(o.formatters, s.format))
        throw new TypeError("Unknown format option provided.");
      g = s.format;
    }
    var y = o.formatters[g], b = m.filter;
    return (typeof s.filter == "function" || d(s.filter)) && (b = s.filter), { addQueryPrefix: typeof s.addQueryPrefix == "boolean" ? s.addQueryPrefix : m.addQueryPrefix, allowDots: typeof s.allowDots == "undefined" ? m.allowDots : !!s.allowDots, charset: h, charsetSentinel: typeof s.charsetSentinel == "boolean" ? s.charsetSentinel : m.charsetSentinel, delimiter: typeof s.delimiter == "undefined" ? m.delimiter : s.delimiter, encode: typeof s.encode == "boolean" ? s.encode : m.encode, encoder: typeof s.encoder == "function" ? s.encoder : m.encoder, encodeValuesOnly: typeof s.encodeValuesOnly == "boolean" ? s.encodeValuesOnly : m.encodeValuesOnly, filter: b, format: g, formatter: y, serializeDate: typeof s.serializeDate == "function" ? s.serializeDate : m.serializeDate, skipNulls: typeof s.skipNulls == "boolean" ? s.skipNulls : m.skipNulls, sort: typeof s.sort == "function" ? s.sort : null, strictNullHandling: typeof s.strictNullHandling == "boolean" ? s.strictNullHandling : m.strictNullHandling };
  };
  t.exports = function(s, h) {
    var g = s, y = w(h), b, E;
    typeof y.filter == "function" ? (E = y.filter, g = E("", g)) : d(y.filter) && (E = y.filter, b = E);
    var _ = [];
    if (typeof g != "object" || g === null)
      return "";
    var j;
    h && h.arrayFormat in a ? j = h.arrayFormat : h && "indices" in h ? j = h.indices ? "indices" : "repeat" : j = "indices";
    var F = a[j];
    if (h && "commaRoundTrip" in h && typeof h.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var M = F === "comma" && h && h.commaRoundTrip;
    b || (b = Object.keys(g)), y.sort && b.sort(y.sort);
    for (var Q = r(), T = 0; T < b.length; ++T) {
      var U = b[T];
      y.skipNulls && g[U] === null || v(_, P(g[U], U, F, M, y.strictNullHandling, y.skipNulls, y.encode ? y.encoder : null, y.filter, y.sort, y.allowDots, y.serializeDate, y.format, y.formatter, y.encodeValuesOnly, y.charset, Q));
    }
    var k = _.join(y.delimiter), B = y.addQueryPrefix === !0 ? "?" : "";
    return y.charsetSentinel && (y.charset === "iso-8859-1" ? B += "utf8=%26%2310003%3B&" : B += "utf8=%E2%9C%93&"), k.length > 0 ? B + k : "";
  };
}), an = z((e, t) => {
  var r = $t(), n = Object.prototype.hasOwnProperty, o = Array.isArray, i = { allowDots: !1, allowPrototypes: !1, allowSparse: !1, arrayLimit: 20, charset: "utf-8", charsetSentinel: !1, comma: !1, decoder: r.decode, delimiter: "&", depth: 5, ignoreQueryPrefix: !1, interpretNumericEntities: !1, parameterLimit: 1e3, parseArrays: !0, plainObjects: !1, strictNullHandling: !1 }, a = function(f) {
    return f.replace(/&#(\d+);/g, function(A, P) {
      return String.fromCharCode(parseInt(P, 10));
    });
  }, d = function(f, A) {
    return f && typeof f == "string" && A.comma && f.indexOf(",") > -1 ? f.split(",") : f;
  }, p = "utf8=%26%2310003%3B", S = "utf8=%E2%9C%93", v = function(f, A) {
    var P = {}, w = A.ignoreQueryPrefix ? f.replace(/^\?/, "") : f, s = A.parameterLimit === 1 / 0 ? void 0 : A.parameterLimit, h = w.split(A.delimiter, s), g = -1, y, b = A.charset;
    if (A.charsetSentinel)
      for (y = 0; y < h.length; ++y)
        h[y].indexOf("utf8=") === 0 && (h[y] === S ? b = "utf-8" : h[y] === p && (b = "iso-8859-1"), g = y, y = h.length);
    for (y = 0; y < h.length; ++y)
      if (y !== g) {
        var E = h[y], _ = E.indexOf("]="), j = _ === -1 ? E.indexOf("=") : _ + 1, F, M;
        j === -1 ? (F = A.decoder(E, i.decoder, b, "key"), M = A.strictNullHandling ? null : "") : (F = A.decoder(E.slice(0, j), i.decoder, b, "key"), M = r.maybeMap(d(E.slice(j + 1), A), function(Q) {
          return A.decoder(Q, i.decoder, b, "value");
        })), M && A.interpretNumericEntities && b === "iso-8859-1" && (M = a(M)), E.indexOf("[]=") > -1 && (M = o(M) ? [M] : M), n.call(P, F) ? P[F] = r.combine(P[F], M) : P[F] = M;
      }
    return P;
  }, O = function(f, A, P, w) {
    for (var s = w ? A : d(A, P), h = f.length - 1; h >= 0; --h) {
      var g, y = f[h];
      if (y === "[]" && P.parseArrays)
        g = [].concat(s);
      else {
        g = P.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var b = y.charAt(0) === "[" && y.charAt(y.length - 1) === "]" ? y.slice(1, -1) : y, E = parseInt(b, 10);
        !P.parseArrays && b === "" ? g = { 0: s } : !isNaN(E) && y !== b && String(E) === b && E >= 0 && P.parseArrays && E <= P.arrayLimit ? (g = [], g[E] = s) : b !== "__proto__" && (g[b] = s);
      }
      s = g;
    }
    return s;
  }, x = function(f, A, P, w) {
    if (f) {
      var s = P.allowDots ? f.replace(/\.([^.[]+)/g, "[$1]") : f, h = /(\[[^[\]]*])/, g = /(\[[^[\]]*])/g, y = P.depth > 0 && h.exec(s), b = y ? s.slice(0, y.index) : s, E = [];
      if (b) {
        if (!P.plainObjects && n.call(Object.prototype, b) && !P.allowPrototypes)
          return;
        E.push(b);
      }
      for (var _ = 0; P.depth > 0 && (y = g.exec(s)) !== null && _ < P.depth; ) {
        if (_ += 1, !P.plainObjects && n.call(Object.prototype, y[1].slice(1, -1)) && !P.allowPrototypes)
          return;
        E.push(y[1]);
      }
      return y && E.push("[" + s.slice(y.index) + "]"), O(E, A, P, w);
    }
  }, m = function(f) {
    if (!f)
      return i;
    if (f.decoder !== null && f.decoder !== void 0 && typeof f.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof f.charset != "undefined" && f.charset !== "utf-8" && f.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var A = typeof f.charset == "undefined" ? i.charset : f.charset;
    return { allowDots: typeof f.allowDots == "undefined" ? i.allowDots : !!f.allowDots, allowPrototypes: typeof f.allowPrototypes == "boolean" ? f.allowPrototypes : i.allowPrototypes, allowSparse: typeof f.allowSparse == "boolean" ? f.allowSparse : i.allowSparse, arrayLimit: typeof f.arrayLimit == "number" ? f.arrayLimit : i.arrayLimit, charset: A, charsetSentinel: typeof f.charsetSentinel == "boolean" ? f.charsetSentinel : i.charsetSentinel, comma: typeof f.comma == "boolean" ? f.comma : i.comma, decoder: typeof f.decoder == "function" ? f.decoder : i.decoder, delimiter: typeof f.delimiter == "string" || r.isRegExp(f.delimiter) ? f.delimiter : i.delimiter, depth: typeof f.depth == "number" || f.depth === !1 ? +f.depth : i.depth, ignoreQueryPrefix: f.ignoreQueryPrefix === !0, interpretNumericEntities: typeof f.interpretNumericEntities == "boolean" ? f.interpretNumericEntities : i.interpretNumericEntities, parameterLimit: typeof f.parameterLimit == "number" ? f.parameterLimit : i.parameterLimit, parseArrays: f.parseArrays !== !1, plainObjects: typeof f.plainObjects == "boolean" ? f.plainObjects : i.plainObjects, strictNullHandling: typeof f.strictNullHandling == "boolean" ? f.strictNullHandling : i.strictNullHandling };
  };
  t.exports = function(f, A) {
    var P = m(A);
    if (f === "" || f === null || typeof f == "undefined")
      return P.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var w = typeof f == "string" ? v(f, P) : f, s = P.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, h = Object.keys(w), g = 0; g < h.length; ++g) {
      var y = h[g], b = x(y, w[y], P, typeof f == "string");
      s = r.merge(s, b, P);
    }
    return P.allowSparse === !0 ? s : r.compact(s);
  };
}), sn = z((e, t) => {
  var r = on(), n = an(), o = yt();
  t.exports = { formats: o, parse: n, stringify: r };
}), ln = (e) => {
  var t, r;
  let n = typeof window != "undefined";
  if (!e && !n)
    return { inBrowser: n };
  let o = e != null ? e : window.navigator.userAgent;
  return { inBrowser: n, isAndroid: o.includes("Android") || o.includes("Adr"), isiOS: /iPad|iPhone|iPod/.test(o), isSafari: o.includes("Safari") && !o.includes("Chrome"), isChrome: o.includes("Chrome"), isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(o), isInApp: /bstar_[a|i]/i.test(o), safariVersion: (r = (t = o.match(/[v|V]ersion\/([\w|.]+)/)) == null ? void 0 : t[1]) != null ? r : "0" };
}, Nt = ln();
function Ht(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
var { toString: Jt } = Object.prototype, { getPrototypeOf: dt } = Object, mt = ((e) => (t) => {
  let r = Jt.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), le = (e) => (e = e.toLowerCase(), (t) => mt(t) === e), We = (e) => (t) => typeof t === e, { isArray: we } = Array, Re = We("undefined");
function un(e) {
  return e !== null && !Re(e) && e.constructor !== null && !Re(e.constructor) && pe(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var Gt = le("ArrayBuffer");
function cn(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Gt(e.buffer), t;
}
var fn = We("string"), pe = We("function"), Kt = We("number"), ht = (e) => e !== null && typeof e == "object", pn = (e) => e === !0 || e === !1, Be = (e) => {
  if (mt(e) !== "object")
    return !1;
  let t = dt(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, yn = le("Date"), dn = le("File"), mn = le("Blob"), hn = le("FileList"), gn = (e) => ht(e) && pe(e.pipe), bn = (e) => {
  let t = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || Jt.call(e) === t || pe(e.toString) && e.toString() === t);
}, vn = le("URLSearchParams"), Sn = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ke(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), we(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    let i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length, d;
    for (n = 0; n < a; n++)
      d = i[n], t.call(null, e[d], d, e);
  }
}
function Qt(e, t) {
  t = t.toLowerCase();
  let r = Object.keys(e), n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
var Xt = (() => typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global)(), Zt = (e) => !Re(e) && e !== Xt;
function st() {
  let { caseless: e } = Zt(this) && this || {}, t = {}, r = (n, o) => {
    let i = e && Qt(t, o) || o;
    Be(t[i]) && Be(n) ? t[i] = st(t[i], n) : Be(n) ? t[i] = st({}, n) : we(n) ? t[i] = n.slice() : t[i] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && ke(arguments[n], r);
  return t;
}
var wn = (e, t, r, { allOwnKeys: n } = {}) => (ke(t, (o, i) => {
  r && pe(o) ? e[i] = Ht(o, r) : e[i] = o;
}, { allOwnKeys: n }), e), En = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), On = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", { value: t.prototype }), r && Object.assign(e.prototype, r);
}, An = (e, t, r, n) => {
  let o, i, a, d = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      a = o[i], (!n || n(a, e, t)) && !d[a] && (t[a] = e[a], d[a] = !0);
    e = r !== !1 && dt(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, Pn = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  let n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, jn = (e) => {
  if (!e)
    return null;
  if (we(e))
    return e;
  let t = e.length;
  if (!Kt(t))
    return null;
  let r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, xn = ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && dt(Uint8Array)), Rn = (e, t) => {
  let r = (e && e[Symbol.iterator]).call(e), n;
  for (; (n = r.next()) && !n.done; ) {
    let o = n.value;
    t.call(e, o[0], o[1]);
  }
}, kn = (e, t) => {
  let r, n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, Nn = le("HTMLFormElement"), Tn = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, r, n) {
  return r.toUpperCase() + n;
}), Tt = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), Cn = le("RegExp"), Yt = (e, t) => {
  let r = Object.getOwnPropertyDescriptors(e), n = {};
  ke(r, (o, i) => {
    t(o, i, e) !== !1 && (n[i] = o);
  }), Object.defineProperties(e, n);
}, Fn = (e) => {
  Yt(e, (t, r) => {
    if (pe(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    let n = e[r];
    if (pe(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, _n = (e, t) => {
  let r = {}, n = (o) => {
    o.forEach((i) => {
      r[i] = !0;
    });
  };
  return we(e) ? n(e) : n(String(e).split(t)), r;
}, Un = () => {
}, Bn = (e, t) => (e = +e, Number.isFinite(e) ? e : t), nt = "abcdefghijklmnopqrstuvwxyz", Ct = "0123456789", er = { DIGIT: Ct, ALPHA: nt, ALPHA_DIGIT: nt + nt.toUpperCase() + Ct }, Dn = (e = 16, t = er.ALPHA_DIGIT) => {
  let r = "", { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function In(e) {
  return !!(e && pe(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
var Ln = (e) => {
  let t = new Array(10), r = (n, o) => {
    if (ht(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        let i = we(n) ? [] : {};
        return ke(n, (a, d) => {
          let p = r(a, o + 1);
          !Re(p) && (i[d] = p);
        }), t[o] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, c = { isArray: we, isArrayBuffer: Gt, isBuffer: un, isFormData: bn, isArrayBufferView: cn, isString: fn, isNumber: Kt, isBoolean: pn, isObject: ht, isPlainObject: Be, isUndefined: Re, isDate: yn, isFile: dn, isBlob: mn, isRegExp: Cn, isFunction: pe, isStream: gn, isURLSearchParams: vn, isTypedArray: xn, isFileList: hn, forEach: ke, merge: st, extend: wn, trim: Sn, stripBOM: En, inherits: On, toFlatObject: An, kindOf: mt, kindOfTest: le, endsWith: Pn, toArray: jn, forEachEntry: Rn, matchAll: kn, isHTMLForm: Nn, hasOwnProperty: Tt, hasOwnProp: Tt, reduceDescriptors: Yt, freezeMethods: Fn, toObjectSet: _n, toCamelCase: Tn, noop: Un, toFiniteNumber: Bn, findKey: Qt, global: Xt, isContextDefined: Zt, ALPHABET: er, generateString: Dn, isSpecCompliantForm: In, toJSONObject: Ln };
function ve(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o);
}
c.inherits(ve, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: c.toJSONObject(this.config), code: this.code, status: this.response && this.response.status ? this.response.status : null };
} });
var tr = ve.prototype, rr = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((e) => {
  rr[e] = { value: e };
});
Object.defineProperties(ve, rr);
Object.defineProperty(tr, "isAxiosError", { value: !0 });
ve.from = (e, t, r, n, o, i) => {
  let a = Object.create(tr);
  return c.toFlatObject(e, a, function(d) {
    return d !== Error.prototype;
  }, (d) => d !== "isAxiosError"), ve.call(a, e.message, t, r, n, o), a.cause = e, a.name = e.name, i && Object.assign(a, i), a;
};
var I = ve, Mn = null;
function lt(e) {
  return c.isPlainObject(e) || c.isArray(e);
}
function nr(e) {
  return c.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Ft(e, t, r) {
  return e ? e.concat(t).map(function(n, o) {
    return n = nr(n), !r && o ? "[" + n + "]" : n;
  }).join(r ? "." : "") : t;
}
function Wn(e) {
  return c.isArray(e) && !e.some(lt);
}
var qn = c.toFlatObject(c, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function zn(e, t, r) {
  if (!c.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = c.toFlatObject(r, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(m, f) {
    return !c.isUndefined(f[m]);
  });
  let n = r.metaTokens, o = r.visitor || S, i = r.dots, a = r.indexes, d = (r.Blob || typeof Blob != "undefined" && Blob) && c.isSpecCompliantForm(t);
  if (!c.isFunction(o))
    throw new TypeError("visitor must be a function");
  function p(m) {
    if (m === null)
      return "";
    if (c.isDate(m))
      return m.toISOString();
    if (!d && c.isBlob(m))
      throw new I("Blob is not supported. Use a Buffer instead.");
    return c.isArrayBuffer(m) || c.isTypedArray(m) ? d && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function S(m, f, A) {
    let P = m;
    if (m && !A && typeof m == "object") {
      if (c.endsWith(f, "{}"))
        f = n ? f : f.slice(0, -2), m = JSON.stringify(m);
      else if (c.isArray(m) && Wn(m) || (c.isFileList(m) || c.endsWith(f, "[]")) && (P = c.toArray(m)))
        return f = nr(f), P.forEach(function(w, s) {
          !(c.isUndefined(w) || w === null) && t.append(a === !0 ? Ft([f], s, i) : a === null ? f : f + "[]", p(w));
        }), !1;
    }
    return lt(m) ? !0 : (t.append(Ft(A, f, i), p(m)), !1);
  }
  let v = [], O = Object.assign(qn, { defaultVisitor: S, convertValue: p, isVisitable: lt });
  function x(m, f) {
    if (!c.isUndefined(m)) {
      if (v.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + f.join("."));
      v.push(m), c.forEach(m, function(A, P) {
        (!(c.isUndefined(A) || A === null) && o.call(t, A, c.isString(P) ? P.trim() : P, f, O)) === !0 && x(A, f ? f.concat(P) : [P]);
      }), v.pop();
    }
  }
  if (!c.isObject(e))
    throw new TypeError("data must be an object");
  return x(e), t;
}
var qe = zn;
function _t(e) {
  let t = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function or(e, t) {
  this._pairs = [], e && qe(e, this, t);
}
var ir = or.prototype;
ir.append = function(e, t) {
  this._pairs.push([e, t]);
};
ir.toString = function(e) {
  let t = e ? function(r) {
    return e.call(this, r, _t);
  } : _t;
  return this._pairs.map(function(r) {
    return t(r[0]) + "=" + t(r[1]);
  }, "").join("&");
};
var ar = or;
function Vn(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function sr(e, t, r) {
  if (!t)
    return e;
  let n = r && r.encode || Vn, o = r && r.serialize, i;
  if (o ? i = o(t, r) : i = c.isURLSearchParams(t) ? t.toString() : new ar(t, r).toString(n), i) {
    let a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
var $n = class {
  constructor() {
    this.handlers = [];
  }
  use(e, t, r) {
    return this.handlers.push({ fulfilled: e, rejected: t, synchronous: r ? r.synchronous : !1, runWhen: r ? r.runWhen : null }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    c.forEach(this.handlers, function(t) {
      t !== null && e(t);
    });
  }
}, Ut = $n, lr = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, Hn = typeof URLSearchParams != "undefined" ? URLSearchParams : ar, Jn = typeof FormData != "undefined" ? FormData : null, Gn = typeof Blob != "undefined" ? Blob : null, Kn = (() => {
  let e;
  return typeof navigator != "undefined" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window != "undefined" && typeof document != "undefined";
})(), Qn = (() => typeof WorkerGlobalScope != "undefined" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), ae = { isBrowser: !0, classes: { URLSearchParams: Hn, FormData: Jn, Blob: Gn }, isStandardBrowserEnv: Kn, isStandardBrowserWebWorkerEnv: Qn, protocols: ["http", "https", "file", "blob", "url", "data"] };
function Xn(e, t) {
  return qe(e, new ae.classes.URLSearchParams(), Object.assign({ visitor: function(r, n, o, i) {
    return ae.isNode && c.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
  } }, t));
}
function Zn(e) {
  return c.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Yn(e) {
  let t = {}, r = Object.keys(e), n, o = r.length, i;
  for (n = 0; n < o; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function eo(e) {
  function t(r, n, o, i) {
    let a = r[i++], d = Number.isFinite(+a), p = i >= r.length;
    return a = !a && c.isArray(o) ? o.length : a, p ? (c.hasOwnProp(o, a) ? o[a] = [o[a], n] : o[a] = n, !d) : ((!o[a] || !c.isObject(o[a])) && (o[a] = []), t(r, n, o[a], i) && c.isArray(o[a]) && (o[a] = Yn(o[a])), !d);
  }
  if (c.isFormData(e) && c.isFunction(e.entries)) {
    let r = {};
    return c.forEachEntry(e, (n, o) => {
      t(Zn(n), o, r, 0);
    }), r;
  }
  return null;
}
var ur = eo, to = { "Content-Type": void 0 };
function ro(e, t, r) {
  if (c.isString(e))
    try {
      return (t || JSON.parse)(e), c.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
var ze = { transitional: lr, adapter: ["xhr", "http"], transformRequest: [function(e, t) {
  let r = t.getContentType() || "", n = r.indexOf("application/json") > -1, o = c.isObject(e);
  if (o && c.isHTMLForm(e) && (e = new FormData(e)), c.isFormData(e))
    return n && n ? JSON.stringify(ur(e)) : e;
  if (c.isArrayBuffer(e) || c.isBuffer(e) || c.isStream(e) || c.isFile(e) || c.isBlob(e))
    return e;
  if (c.isArrayBufferView(e))
    return e.buffer;
  if (c.isURLSearchParams(e))
    return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
  let i;
  if (o) {
    if (r.indexOf("application/x-www-form-urlencoded") > -1)
      return Xn(e, this.formSerializer).toString();
    if ((i = c.isFileList(e)) || r.indexOf("multipart/form-data") > -1) {
      let a = this.env && this.env.FormData;
      return qe(i ? { "files[]": e } : e, a && new a(), this.formSerializer);
    }
  }
  return o || n ? (t.setContentType("application/json", !1), ro(e)) : e;
}], transformResponse: [function(e) {
  let t = this.transitional || ze.transitional, r = t && t.forcedJSONParsing, n = this.responseType === "json";
  if (e && c.isString(e) && (r && !this.responseType || n)) {
    let o = !(t && t.silentJSONParsing) && n;
    try {
      return JSON.parse(e);
    } catch (i) {
      if (o)
        throw i.name === "SyntaxError" ? I.from(i, I.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return e;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: ae.classes.FormData, Blob: ae.classes.Blob }, validateStatus: function(e) {
  return e >= 200 && e < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*" } } };
c.forEach(["delete", "get", "head"], function(e) {
  ze.headers[e] = {};
});
c.forEach(["post", "put", "patch"], function(e) {
  ze.headers[e] = c.merge(to);
});
var gt = ze, no = c.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), oo = (e) => {
  let t = {}, r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && no[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Bt = Symbol("internals");
function xe(e) {
  return e && String(e).trim().toLowerCase();
}
function De(e) {
  return e === !1 || e == null ? e : c.isArray(e) ? e.map(De) : String(e);
}
function io(e) {
  let t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
function ao(e) {
  return /^[-_a-zA-Z]+$/.test(e.trim());
}
function ot(e, t, r, n, o) {
  if (c.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!c.isString(t)) {
    if (c.isString(n))
      return t.indexOf(n) !== -1;
    if (c.isRegExp(n))
      return n.test(t);
  }
}
function so(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function lo(e, t) {
  let r = c.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, { value: function(o, i, a) {
      return this[n].call(this, t, o, i, a);
    }, configurable: !0 });
  });
}
var Ve = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, r) {
    let n = this;
    function o(a, d, p) {
      let S = xe(d);
      if (!S)
        throw new Error("header name must be a non-empty string");
      let v = c.findKey(n, S);
      (!v || n[v] === void 0 || p === !0 || p === void 0 && n[v] !== !1) && (n[v || d] = De(a));
    }
    let i = (a, d) => c.forEach(a, (p, S) => o(p, S, d));
    return c.isPlainObject(e) || e instanceof this.constructor ? i(e, t) : c.isString(e) && (e = e.trim()) && !ao(e) ? i(oo(e), t) : e != null && o(t, e, r), this;
  }
  get(e, t) {
    if (e = xe(e), e) {
      let r = c.findKey(this, e);
      if (r) {
        let n = this[r];
        if (!t)
          return n;
        if (t === !0)
          return io(n);
        if (c.isFunction(t))
          return t.call(this, n, r);
        if (c.isRegExp(t))
          return t.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = xe(e), e) {
      let r = c.findKey(this, e);
      return !!(r && this[r] !== void 0 && (!t || ot(this, this[r], r, t)));
    }
    return !1;
  }
  delete(e, t) {
    let r = this, n = !1;
    function o(i) {
      if (i = xe(i), i) {
        let a = c.findKey(r, i);
        a && (!t || ot(r, r[a], a, t)) && (delete r[a], n = !0);
      }
    }
    return c.isArray(e) ? e.forEach(o) : o(e), n;
  }
  clear(e) {
    let t = Object.keys(this), r = t.length, n = !1;
    for (; r--; ) {
      let o = t[r];
      (!e || ot(this, this[o], o, e, !0)) && (delete this[o], n = !0);
    }
    return n;
  }
  normalize(e) {
    let t = this, r = {};
    return c.forEach(this, (n, o) => {
      let i = c.findKey(r, o);
      if (i) {
        t[i] = De(n), delete t[o];
        return;
      }
      let a = e ? so(o) : String(o).trim();
      a !== o && delete t[o], t[a] = De(n), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    let t = /* @__PURE__ */ Object.create(null);
    return c.forEach(this, (r, n) => {
      r != null && r !== !1 && (t[n] = e && c.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    let r = new this(e);
    return t.forEach((n) => r.set(n)), r;
  }
  static accessor(e) {
    let t = (this[Bt] = this[Bt] = { accessors: {} }).accessors, r = this.prototype;
    function n(o) {
      let i = xe(o);
      t[i] || (lo(r, o), t[i] = !0);
    }
    return c.isArray(e) ? e.forEach(n) : n(e), this;
  }
};
Ve.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
c.freezeMethods(Ve.prototype);
c.freezeMethods(Ve);
var se = Ve;
function it(e, t) {
  let r = this || gt, n = t || r, o = se.from(n.headers), i = n.data;
  return c.forEach(e, function(a) {
    i = a.call(r, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function cr(e) {
  return !!(e && e.__CANCEL__);
}
function fr(e, t, r) {
  I.call(this, e == null ? "canceled" : e, I.ERR_CANCELED, t, r), this.name = "CanceledError";
}
c.inherits(fr, I, { __CANCEL__: !0 });
var $e = fr;
function uo(e, t, r) {
  let n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new I("Request failed with status code " + r.status, [I.ERR_BAD_REQUEST, I.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4], r.config, r.request, r));
}
var co = ae.isStandardBrowserEnv ? function() {
  return { write: function(e, t, r, n, o, i) {
    let a = [];
    a.push(e + "=" + encodeURIComponent(t)), c.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), c.isString(n) && a.push("path=" + n), c.isString(o) && a.push("domain=" + o), i === !0 && a.push("secure"), document.cookie = a.join("; ");
  }, read: function(e) {
    let t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
    return t ? decodeURIComponent(t[3]) : null;
  }, remove: function(e) {
    this.write(e, "", Date.now() - 864e5);
  } };
}() : function() {
  return { write: function() {
  }, read: function() {
    return null;
  }, remove: function() {
  } };
}();
function fo(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function po(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function pr(e, t) {
  return e && !fo(t) ? po(e, t) : t;
}
var yo = ae.isStandardBrowserEnv ? function() {
  let e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a"), r;
  function n(o) {
    let i = o;
    return e && (t.setAttribute("href", i), i = t.href), t.setAttribute("href", i), { href: t.href, protocol: t.protocol ? t.protocol.replace(/:$/, "") : "", host: t.host, search: t.search ? t.search.replace(/^\?/, "") : "", hash: t.hash ? t.hash.replace(/^#/, "") : "", hostname: t.hostname, port: t.port, pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname };
  }
  return r = n(window.location.href), function(o) {
    let i = c.isString(o) ? n(o) : o;
    return i.protocol === r.protocol && i.host === r.host;
  };
}() : function() {
  return function() {
    return !0;
  };
}();
function mo(e) {
  let t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function ho(e, t) {
  e = e || 10;
  let r = new Array(e), n = new Array(e), o = 0, i = 0, a;
  return t = t !== void 0 ? t : 1e3, function(d) {
    let p = Date.now(), S = n[i];
    a || (a = p), r[o] = d, n[o] = p;
    let v = i, O = 0;
    for (; v !== o; )
      O += r[v++], v = v % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), p - a < t)
      return;
    let x = S && p - S;
    return x ? Math.round(O * 1e3 / x) : void 0;
  };
}
var go = ho;
function Dt(e, t) {
  let r = 0, n = go(50, 250);
  return (o) => {
    let i = o.loaded, a = o.lengthComputable ? o.total : void 0, d = i - r, p = n(d), S = i <= a;
    r = i;
    let v = { loaded: i, total: a, progress: a ? i / a : void 0, bytes: d, rate: p || void 0, estimated: p && a && S ? (a - i) / p : void 0, event: o };
    v[t ? "download" : "upload"] = !0, e(v);
  };
}
var bo = typeof XMLHttpRequest != "undefined", vo = bo && function(e) {
  return new Promise(function(t, r) {
    let n = e.data, o = se.from(e.headers).normalize(), i = e.responseType, a;
    function d() {
      e.cancelToken && e.cancelToken.unsubscribe(a), e.signal && e.signal.removeEventListener("abort", a);
    }
    c.isFormData(n) && (ae.isStandardBrowserEnv || ae.isStandardBrowserWebWorkerEnv) && o.setContentType(!1);
    let p = new XMLHttpRequest();
    if (e.auth) {
      let x = e.auth.username || "", m = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      o.set("Authorization", "Basic " + btoa(x + ":" + m));
    }
    let S = pr(e.baseURL, e.url);
    p.open(e.method.toUpperCase(), sr(S, e.params, e.paramsSerializer), !0), p.timeout = e.timeout;
    function v() {
      if (!p)
        return;
      let x = se.from("getAllResponseHeaders" in p && p.getAllResponseHeaders()), m = { data: !i || i === "text" || i === "json" ? p.responseText : p.response, status: p.status, statusText: p.statusText, headers: x, config: e, request: p };
      uo(function(f) {
        t(f), d();
      }, function(f) {
        r(f), d();
      }, m), p = null;
    }
    if ("onloadend" in p ? p.onloadend = v : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(v);
    }, p.onabort = function() {
      !p || (r(new I("Request aborted", I.ECONNABORTED, e, p)), p = null);
    }, p.onerror = function() {
      r(new I("Network Error", I.ERR_NETWORK, e, p)), p = null;
    }, p.ontimeout = function() {
      let x = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded", m = e.transitional || lr;
      e.timeoutErrorMessage && (x = e.timeoutErrorMessage), r(new I(x, m.clarifyTimeoutError ? I.ETIMEDOUT : I.ECONNABORTED, e, p)), p = null;
    }, ae.isStandardBrowserEnv) {
      let x = (e.withCredentials || yo(S)) && e.xsrfCookieName && co.read(e.xsrfCookieName);
      x && o.set(e.xsrfHeaderName, x);
    }
    n === void 0 && o.setContentType(null), "setRequestHeader" in p && c.forEach(o.toJSON(), function(x, m) {
      p.setRequestHeader(m, x);
    }), c.isUndefined(e.withCredentials) || (p.withCredentials = !!e.withCredentials), i && i !== "json" && (p.responseType = e.responseType), typeof e.onDownloadProgress == "function" && p.addEventListener("progress", Dt(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && p.upload && p.upload.addEventListener("progress", Dt(e.onUploadProgress)), (e.cancelToken || e.signal) && (a = (x) => {
      !p || (r(!x || x.type ? new $e(null, e, p) : x), p.abort(), p = null);
    }, e.cancelToken && e.cancelToken.subscribe(a), e.signal && (e.signal.aborted ? a() : e.signal.addEventListener("abort", a)));
    let O = mo(S);
    if (O && ae.protocols.indexOf(O) === -1) {
      r(new I("Unsupported protocol " + O + ":", I.ERR_BAD_REQUEST, e));
      return;
    }
    p.send(n || null);
  });
}, Ie = { http: Mn, xhr: vo };
c.forEach(Ie, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (r) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
var So = { getAdapter: (e) => {
  e = c.isArray(e) ? e : [e];
  let { length: t } = e, r, n;
  for (let o = 0; o < t && (r = e[o], !(n = c.isString(r) ? Ie[r.toLowerCase()] : r)); o++)
    ;
  if (!n)
    throw n === !1 ? new I(`Adapter ${r} is not supported by the environment`, "ERR_NOT_SUPPORT") : new Error(c.hasOwnProp(Ie, r) ? `Adapter '${r}' is not available in the build` : `Unknown adapter '${r}'`);
  if (!c.isFunction(n))
    throw new TypeError("adapter is not a function");
  return n;
}, adapters: Ie };
function at(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new $e(null, e);
}
function It(e) {
  return at(e), e.headers = se.from(e.headers), e.data = it.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), So.getAdapter(e.adapter || gt.adapter)(e).then(function(t) {
    return at(e), t.data = it.call(e, e.transformResponse, t), t.headers = se.from(t.headers), t;
  }, function(t) {
    return cr(t) || (at(e), t && t.response && (t.response.data = it.call(e, e.transformResponse, t.response), t.response.headers = se.from(t.response.headers))), Promise.reject(t);
  });
}
var Lt = (e) => e instanceof se ? e.toJSON() : e;
function Se(e, t) {
  t = t || {};
  let r = {};
  function n(S, v, O) {
    return c.isPlainObject(S) && c.isPlainObject(v) ? c.merge.call({ caseless: O }, S, v) : c.isPlainObject(v) ? c.merge({}, v) : c.isArray(v) ? v.slice() : v;
  }
  function o(S, v, O) {
    if (c.isUndefined(v)) {
      if (!c.isUndefined(S))
        return n(void 0, S, O);
    } else
      return n(S, v, O);
  }
  function i(S, v) {
    if (!c.isUndefined(v))
      return n(void 0, v);
  }
  function a(S, v) {
    if (c.isUndefined(v)) {
      if (!c.isUndefined(S))
        return n(void 0, S);
    } else
      return n(void 0, v);
  }
  function d(S, v, O) {
    if (O in t)
      return n(S, v);
    if (O in e)
      return n(void 0, S);
  }
  let p = { url: i, method: i, data: i, baseURL: a, transformRequest: a, transformResponse: a, paramsSerializer: a, timeout: a, timeoutMessage: a, withCredentials: a, adapter: a, responseType: a, xsrfCookieName: a, xsrfHeaderName: a, onUploadProgress: a, onDownloadProgress: a, decompress: a, maxContentLength: a, maxBodyLength: a, beforeRedirect: a, transport: a, httpAgent: a, httpsAgent: a, cancelToken: a, socketPath: a, responseEncoding: a, validateStatus: d, headers: (S, v) => o(Lt(S), Lt(v), !0) };
  return c.forEach(Object.keys(e).concat(Object.keys(t)), function(S) {
    let v = p[S] || o, O = v(e[S], t[S], S);
    c.isUndefined(O) && v !== d || (r[S] = O);
  }), r;
}
var yr = "1.3.4", bt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  bt[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var Mt = {};
bt.transitional = function(e, t, r) {
  function n(o, i) {
    return "[Axios v" + yr + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, a) => {
    if (e === !1)
      throw new I(n(i, " has been removed" + (t ? " in " + t : "")), I.ERR_DEPRECATED);
    return t && !Mt[i] && (Mt[i] = !0, console.warn(n(i, " has been deprecated since v" + t + " and will be removed in the near future"))), e ? e(o, i, a) : !0;
  };
};
function wo(e, t, r) {
  if (typeof e != "object")
    throw new I("options must be an object", I.ERR_BAD_OPTION_VALUE);
  let n = Object.keys(e), o = n.length;
  for (; o-- > 0; ) {
    let i = n[o], a = t[i];
    if (a) {
      let d = e[i], p = d === void 0 || a(d, i, e);
      if (p !== !0)
        throw new I("option " + i + " must be " + p, I.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new I("Unknown option " + i, I.ERR_BAD_OPTION);
  }
}
var ut = { assertOptions: wo, validators: bt }, fe = ut.validators, Me = class {
  constructor(e) {
    this.defaults = e, this.interceptors = { request: new Ut(), response: new Ut() };
  }
  request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = Se(this.defaults, t);
    let { transitional: r, paramsSerializer: n, headers: o } = t;
    r !== void 0 && ut.assertOptions(r, { silentJSONParsing: fe.transitional(fe.boolean), forcedJSONParsing: fe.transitional(fe.boolean), clarifyTimeoutError: fe.transitional(fe.boolean) }, !1), n !== void 0 && ut.assertOptions(n, { encode: fe.function, serialize: fe.function }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i;
    i = o && c.merge(o.common, o[t.method]), i && c.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (m) => {
      delete o[m];
    }), t.headers = se.concat(i, o);
    let a = [], d = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(t) === !1 || (d = d && m.synchronous, a.unshift(m.fulfilled, m.rejected));
    });
    let p = [];
    this.interceptors.response.forEach(function(m) {
      p.push(m.fulfilled, m.rejected);
    });
    let S, v = 0, O;
    if (!d) {
      let m = [It.bind(this), void 0];
      for (m.unshift.apply(m, a), m.push.apply(m, p), O = m.length, S = Promise.resolve(t); v < O; )
        S = S.then(m[v++], m[v++]);
      return S;
    }
    O = a.length;
    let x = t;
    for (v = 0; v < O; ) {
      let m = a[v++], f = a[v++];
      try {
        x = m(x);
      } catch (A) {
        f.call(this, A);
        break;
      }
    }
    try {
      S = It.call(this, x);
    } catch (m) {
      return Promise.reject(m);
    }
    for (v = 0, O = p.length; v < O; )
      S = S.then(p[v++], p[v++]);
    return S;
  }
  getUri(e) {
    e = Se(this.defaults, e);
    let t = pr(e.baseURL, e.url);
    return sr(t, e.params, e.paramsSerializer);
  }
};
c.forEach(["delete", "get", "head", "options"], function(e) {
  Me.prototype[e] = function(t, r) {
    return this.request(Se(r || {}, { method: e, url: t, data: (r || {}).data }));
  };
});
c.forEach(["post", "put", "patch"], function(e) {
  function t(r) {
    return function(n, o, i) {
      return this.request(Se(i || {}, { method: e, headers: r ? { "Content-Type": "multipart/form-data" } : {}, url: n, data: o }));
    };
  }
  Me.prototype[e] = t(), Me.prototype[e + "Form"] = t(!0);
});
var Le = Me, dr = class {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(n) {
      t = n;
    });
    let r = this;
    this.promise.then((n) => {
      if (!r._listeners)
        return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](n);
      r._listeners = null;
    }), this.promise.then = (n) => {
      let o, i = new Promise((a) => {
        r.subscribe(a), o = a;
      }).then(n);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, e(function(n, o, i) {
      r.reason || (r.reason = new $e(n, o, i), t(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners)
      return;
    let t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  static source() {
    let e;
    return { token: new dr(function(t) {
      e = t;
    }), cancel: e };
  }
}, Eo = dr;
function Oo(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function Ao(e) {
  return c.isObject(e) && e.isAxiosError === !0;
}
var ct = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511 };
Object.entries(ct).forEach(([e, t]) => {
  ct[t] = e;
});
var Po = ct;
function mr(e) {
  let t = new Le(e), r = Ht(Le.prototype.request, t);
  return c.extend(r, Le.prototype, t, { allOwnKeys: !0 }), c.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(n) {
    return mr(Se(e, n));
  }, r;
}
var q = mr(gt);
q.Axios = Le;
q.CanceledError = $e;
q.CancelToken = Eo;
q.isCancel = cr;
q.VERSION = yr;
q.toFormData = qe;
q.AxiosError = I;
q.Cancel = q.CanceledError;
q.all = function(e) {
  return Promise.all(e);
};
q.spread = Oo;
q.isAxiosError = Ao;
q.mergeConfig = Se;
q.AxiosHeaders = se;
q.formToJSON = (e) => ur(c.isHTMLForm(e) ? new FormData(e) : e);
q.HttpStatusCode = Po;
q.default = q;
Gr(sn());
var jo = ((e) => (e[e.OK = 0] = "OK", e[e.ErrForbidden = -403] = "ErrForbidden", e[e.ErrNotFound = -404] = "ErrNotFound", e[e.ErrUserNotExist = -626] = "ErrUserNotExist", e[e.ErrRegionLimit = 10004001] = "ErrRegionLimit", e[e.ErrArchive = 10004002] = "ErrArchive", e[e.ErrEpisode = 10004003] = "ErrEpisode", e[e.ErrNeedPremium = 10004004] = "ErrNeedPremium", e[e.ErrNeedLogin = 10004005] = "ErrNeedLogin", e[e.ErrNeedBuvid = 10023006] = "ErrNeedBuvid", e[e.ErrSubmitFail = 10023007] = "ErrSubmitFail", e[e.ErrCommentClose = 10023008] = "ErrCommentClose", e[e.ErrAccountOrPassword = -629] = "ErrAccountOrPassword", e[e.ErrCaptcha = -105] = "ErrCaptcha", e[e.DecryptError = 86e3] = "DecryptError", e[e.NeedCaptcha = 86001] = "NeedCaptcha", e[e.EmptyArea = 86003] = "EmptyArea", e[e.EmptyPhone = 86004] = "EmptyPhone", e[e.ErrorPhone = 86005] = "ErrorPhone", e[e.BanPhone = 86015] = "BanPhone", e[e.FrequentSend = 86200] = "FrequentSend", e[e.ErrorSmsCode = 86202] = "ErrorSmsCode", e[e.LimitSend = 86203] = "LimitSend", e[e.TooManySend = 86204] = "TooManySend", e[e.OverdueSmsCode = 86205] = "OverdueSmsCode", e[e.DiffArea = 86206] = "DiffArea", e[e.DiffPhone = 86207] = "DiffPhone", e[e.UnlegalSend = 86208] = "UnlegalSend", e[e.ErrorPhone2 = 66031] = "ErrorPhone2", e[e.ErrorAccountOrPassword = -629] = "ErrorAccountOrPassword", e[e.ErrorCaptcha = -105] = "ErrorCaptcha", e[e.PhoneLimit = 86071] = "PhoneLimit", e[e.AreaLimit = 10003003] = "AreaLimit", e[e.EmailSendFail = 86250] = "EmailSendFail", e[e.EmailSendInvalid = 86251] = "EmailSendInvalid", e[e.EmailSent = 86252] = "EmailSent", e[e.TooManyEmailSend = 86253] = "TooManyEmailSend", e[e.TooManyEmailSendIp = 86254] = "TooManyEmailSendIp", e[e.OverdueEmail = 86255] = "OverdueEmail", e[e.DiffEmail = 86256] = "DiffEmail", e[e.ErrorEmailCode = 86257] = "ErrorEmailCode", e[e.EmailInvalid = 86258] = "EmailInvalid", e[e.InvalidPassword = 86306] = "InvalidPassword", e[e.OccupyEmail = 86259] = "OccupyEmail", e[e.ResentEmailCode = 86150] = "ResentEmailCode", e[e.QrcodeScanTimeout = 10018100] = "QrcodeScanTimeout", e[e.QrcodeNotScan = 10018101] = "QrcodeNotScan", e[e.QrcodeScaned = 10018102] = "QrcodeScaned", e))(jo || {}), xo = { apiUrl: "//uat-api.bilibili.tv", studioUrl: "http://uat-studio.bilibili.tv", loginUrl: "//uat-passport.bilibili.tv", fmLoginUrl: "//uat-passport.pogo.fm", domain: "http://uat-www.bilibili.tv", fmDomain: "http://uat-www.pogo.fm" }, Ro = { apiUrl: "//uat-api.bilibili.tv", studioUrl: "http://uat-studio.bilibili.tv", loginUrl: "//uat-passport.bilibili.tv", fmLoginUrl: "//uat-passport.pogo.fm", domain: "http://uat-www.bilibili.tv", fmDomain: "http://uat-www.pogo.fm" }, ko = { apiUrl: "//pre-api.bilibili.tv", studioUrl: "http://pre-studio.bilibili.tv", loginUrl: "//pre-passport.bilibili.tv", fmLoginUrl: "//pre-passport.pogo.fm", domain: "http://pre-www.bilibili.tv", fmDomain: "http://pre-www.pogo.fm" }, hr = { apiUrl: "//api.bilibili.tv", studioUrl: "https://studio.bilibili.tv", loginUrl: "//passport.bilibili.tv", fmLoginUrl: "//passport.pogo.fm", domain: "https://www.bilibili.tv", fmDomain: "https://www.pogo.fm" }, No = /* @__PURE__ */ new Map([["dev", xo], ["uat", Ro], ["pre", ko], ["prod", hr]]), To = (e) => {
  var t;
  return (t = No.get(e)) != null ? t : hr;
}, Wt, qt, zt;
!Nt.isSafari || Number((zt = (qt = (Wt = Nt) == null ? void 0 : Wt.safariVersion) == null ? void 0 : qt.split(".")) == null ? void 0 : zt[0]) >= 14;
var Co = (e, t) => {
  let r = To(e);
  return (n, o) => `${r.domain}/${t}/${n}${o ? `?${o}` : ""}`;
};
const Fo = /* @__PURE__ */ new Map([
  ["en", {
    title: "This website uses cookies.",
    descPrefix: "We use cookies for simplifying relevant operations (such as remain logged in) and improving your experience by measuring how you use the site. By continuing to use our site, you agree to our use of cookies. Learn more from ",
    linkText: "Privacy Policy",
    descSuffix: "",
    confirmText: "Got it"
  }],
  ["th", {
    title: "เว็บไซต์นี้ใช้คุกกี้",
    descPrefix: "เราใช้คุกกี้เพื่อใช้เว็บไซต์ของเราได้ง่ายขึ้น (เช่น การคงสถานะการเข้าสู่ระบบ) และปรับปรุงประสบการณ์ของคุณด้วยการอ้างอิงว่าคุณใช้งานเว็บไซต์อย่างไร การใช้เว็บไซต์ของเราต่อไป นั่นเป็นการแสดงว่าคุณยินยอมการใช้งานคุกกี้ของเรา สามารถเรียนรู้เพิ่มเติมได้จาก",
    linkText: "นโยบายความเป็นส่วนตัว",
    descSuffix: "",
    confirmText: "ทราบแล้ว"
  }],
  ["vi", {
    title: "Trang web này sử dụng Cookie",
    descPrefix: "Chúng tôi sử dụng cookie để đơn giản hóa các thao tác (ví dụ như duy trì trạng thái đăng nhập), đồng thời cải thiện trải nghiệm của bạn bằng cách đánh giá cách bạn sử dụng trang web. Tiếp tục sử dụng trang web của chúng tôi tức là bạn đồng ý với việc chúng tôi sử dụng cookie. Để biết thêm thông tin chi tiết, vui lòng xem tại ",
    linkText: "Chính sách riêng tư",
    descSuffix: ".",
    confirmText: "Tôi đã hiểu"
  }],
  ["id", {
    title: "Situs web ini menggunakan Cookie",
    descPrefix: "Kami menggunakan cookie untuk mempermudah (seperti tetap dalam keadaan login) dan meningkatkan pengalaman penggunaan dengan mengukur cara Anda menggunakan situs web. Dengan melanjutkan untuk menggunakan situs web kami, Anda telah menyetujui untuk menggunakan cookies kami. Pelajari lebih lanjut tentang ",
    linkText: "Kebijakan Privasi",
    descSuffix: ".",
    confirmText: "Saya mengerti"
  }],
  ["ms", {
    title: "Web ini menggunakan Cookie",
    descPrefix: "Kami menggunakan cookie untuk memudahkan operasi yang berkaitan (seperti kekalkan status log masuk) dan memperbaiki pengalaman anda dengan mengukur cara anda menggunakan web. Dengan terus menggunakan web kami, bermakna anda bersetuju dengan penggunaan cookie kami. Ketahui lebih lanjut daripada ",
    linkText: "Dasar Privasi",
    descSuffix: ".",
    confirmText: "Ambil maklum"
  }]
]), _o = Fo, Uo = ["href"], Bo = /* @__PURE__ */ kr({
  __name: "cookie-info",
  props: {
    env: null,
    locale: null
  },
  setup(e) {
    const t = e, { locale: r, env: n } = Nr(t), o = Co(ie(n), ie(r)), i = "confirm-cookie-info", a = Tr(!1), d = "bstar-cookie-info", p = Cr(() => _o.get(ie(r)));
    Fr(() => {
      localStorage.getItem(i) || (a.value = !0);
    });
    const S = o("privacy-policy"), v = () => {
      localStorage.setItem(i, "true"), a.value = !1;
    };
    return (O, x) => {
      var m, f, A, P;
      return a.value ? (_r(), Ur("div", {
        key: 0,
        class: be(d)
      }, [
        Ue("div", {
          class: be(`${d}__text`)
        }, [
          Ue("h3", {
            class: be(`${d}__title`)
          }, je((m = ie(p)) == null ? void 0 : m.title), 3),
          Ue("span", {
            class: be(`${d}__desc`)
          }, [
            rt(je((f = ie(p)) == null ? void 0 : f.descPrefix), 1),
            Ue("a", {
              class: be(`${d}__link`),
              href: ie(S),
              target: "_blank"
            }, je((A = ie(p)) == null ? void 0 : A.linkText), 11, Uo),
            rt(je((P = ie(p)) == null ? void 0 : P.descSuffix), 1)
          ], 2)
        ], 2),
        Br(ie(Wr), {
          class: be(`${d}__confirm`),
          size: "large",
          type: "default",
          bold: !0,
          onClick: v
        }, {
          default: Dr(() => {
            var w;
            return [
              rt(je((w = ie(p)) == null ? void 0 : w.confirmText), 1)
            ];
          }),
          _: 1
        }, 8, ["class"])
      ])) : Ir("", !0);
    };
  }
});
const Do = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, o] of t)
    r[n] = o;
  return r;
}, Io = /* @__PURE__ */ Do(Bo, [["__scopeId", "data-v-57f652c1"]]), Wo = (e, t) => ({ renderCookieInfo: () => {
  const n = Lr(Io, t), o = document.getElementById(e);
  o && Mr(n, o);
} });
export {
  Io as BCookieInfo,
  Wo as useRenderCookieInfo
};
//# sourceMappingURL=cookie-info.es.js.map
